import type { ProjectState } from "./types";

export interface ScholarFlowShareBundle {
  format: "scholarflow-project";
  schemaVersion: 1;
  exportedAt: string;
  prompt: string;
  project: ProjectState;
}

export function sanitizeProjectForShare(state: ProjectState): ProjectState {
  return {
    ...state,
    id: crypto.randomUUID(),
    refinedPrompts: {},
    memory: { ...state.memory, capsules: [] },
    workspace: { absolutePath: "", handleName: "" },
    referencePapers: state.referencePapers.map((paper) => ({
      ...paper,
      name: "reference-paper.pdf",
    })),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}

export function buildShareBundle(
  state: ProjectState,
  prompt: string,
): ScholarFlowShareBundle {
  return {
    format: "scholarflow-project",
    schemaVersion: 1,
    exportedAt: new Date().toISOString(),
    prompt,
    project: state,
  };
}

export function parseShareBundle(input: string): ScholarFlowShareBundle {
  const parsed = JSON.parse(input) as Partial<ScholarFlowShareBundle>;
  if (
    parsed.format !== "scholarflow-project" ||
    parsed.schemaVersion !== 1 ||
    !parsed.project ||
    typeof parsed.project !== "object"
  ) {
    throw new Error("这不是有效的 ScholarFlow 项目包。");
  }
  return parsed as ScholarFlowShareBundle;
}
